import script from "./MembershipChangedTriggerSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MembershipChangedTriggerSidebar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__